import { IApplicationState } from '../../types/redux';

export function getDescription(state: IApplicationState) {
  return state.newbuilding.description;
}
